import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import PageLoader from "components/PageLoader";

const LazyTicket = lazy(() => import('pages/Ticket'));
// const LazyTicketDetail = lazy(() => import('pages/TicketDetail'));

function TicketRoute() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<LazyTicket />} />
        {/* <Route path="/:ticket_id" element={<LazyTicketDetail />} /> */}
      </Routes>
    </Suspense>
  );
}

export default TicketRoute;
